import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import useAnalyticsContext from "../../hooks/useAnalyticsContext.js";
import { trackCTA, trackLead } from "../../lib/analytics";

const STEP_KEYS = [
  "createSpace",
  "inviteGuests",
  "captureDay",
  "curateGallery",
  "reliveForever",
];

const Journey = () => {
  const { t } = useTranslation();
  const analyticsContext = useAnalyticsContext();

  return (
    <section id="how-it-works" className="section" style={{ paddingTop: "0px" }}>
      <div
        data-w-id="010d51b9-9151-82fd-bfd8-6c2e1374a5ac"
        className="container home-serv"
      >
        <div className="full-header-div">
          <div className="pad-20">
            <h2 className="heading-136">{t("home.journey.heading")}</h2>
          </div>
          <div className="paragraph-wrap">
            <p className="body-16">{t("home.journey.intro")}</p>
          </div>
        </div>
        <div className="list-wrap">
          {STEP_KEYS.map((key, index) => (
            <div key={key} className="list-row">
              <div className="no-div">
                <div className="no">
                  {t("home.journey.stepLabel", { number: index + 1 })}
                </div>
              </div>
              <div className="row-heading-div">
                {/* <h3>, not <h4>. The section's own heading above is the
                    <h2>, so a step is its child and an <h4> here skips a
                    level for every reader that walks the outline — a screen
                    reader, an outline extractor, a crawler.

                    The tag is the whole change: `.heading-38` already sets
                    font-family, size, weight, line-height and margin-top, all
                    at class specificity, and h3 and h4 differ only in the four
                    properties it overrides plus a margin-bottom the two share.
                    The Greek face swap keys off `.heading-38` as well, not off
                    the tag. Nothing about this section renders differently. */}
                <h3 className="heading-38">
                  {t(`home.journey.steps.${key}.title`)}
                </h3>
              </div>
              <div className="row-body-div serv">
                <p className="body-15">
                  {t(`home.journey.steps.${key}.body`)}
                </p>
              </div>
            </div>
          ))}
        </div>
        <Button
          href={`${import.meta.env.VITE_APP_URL}/couple/create-event`}
          text={t("home.journey.cta")}
          dataWId="67d84146-8342-a81f-f31d-9603c731480a"
          target="_blank"
          className="button-lg"
          onClick={() => {
            trackCTA("journey", { ...analyticsContext, ctaName: "register" });
            trackLead("journey", { ...analyticsContext, ctaName: "register" });
          }}
        />
      </div>
    </section>
  );
};
export default Journey;
